import ScheduleDetail from "../../components/handyman/schedule/schedule-detail";

const ScheduleDetailPage = () => {
  return <ScheduleDetail />;
};

export default ScheduleDetailPage;

